import Store from 'redux/store';
import {
  FETCH_PRODUCTS,
  FETCH_PRODUCTS_FAIL,
  FETCH_PRODUCTS_SUCCESS,

  FETCH_PRODUCTS_GENERIC,
  FETCH_PRODUCTS_GENERIC_FAIL,
  FETCH_PRODUCTS_GENERIC_SUCCESS,

  FETCH_PRODUCTS_RELATED,
  FETCH_PRODUCTS_RELATED_FAIL,
  FETCH_PRODUCTS_RELATED_SUCCESS,

  RESET_RELATED_PRODUCTS
} from 'redux/Reducers/Products/ProductsReducer';
import { cloudloyalty, genericSupplierEndpoint } from '../clients';

// eslint-disable-next-line default-param-last
export const FetchProducts = async (User, finallyCallback = () => { }, { sku }) => {
  Store.dispatch({ type: FETCH_PRODUCTS });
  cloudloyalty(User).get(`/v2/products/skus/${sku}`).then((response) => {
    Store.dispatch({
      type: FETCH_PRODUCTS_SUCCESS,
      payload: {
        ...response,
      },
    });
  }).catch((e) => {
    Store.dispatch({
      type: FETCH_PRODUCTS_FAIL, error: e,
    });
  })
    .finally(() => {
      finallyCallback();
    });
};

export const FetchProductsGeneric = async (User, finallyCallback = () => { }, { sku }) => {
  Store.dispatch({ type: FETCH_PRODUCTS_GENERIC });
  genericSupplierEndpoint(User).get(`/Product/Sku/${sku}`).then((response) => {
    Store.dispatch({
      type: FETCH_PRODUCTS_GENERIC_SUCCESS,
      payload: {
        ...response,
      },
    });
  }).catch((e) => {
    Store.dispatch({
      type: FETCH_PRODUCTS_GENERIC_FAIL, error: e,
    });
  })
    .finally(() => {
      finallyCallback();
    });
};

export const FetchProductsRelated = async (User, finallyCallback = () => { }, { sku }) => {
  Store.dispatch({ type: FETCH_PRODUCTS_RELATED });
  genericSupplierEndpoint(User).get(`/Product/RelatedProducts/${sku}`).then((response) => {
    Store.dispatch({
      type: FETCH_PRODUCTS_RELATED_SUCCESS,
      payload: {
        ...response,
      },
    });
  }).catch((e) => {
    Store.dispatch({
      type: FETCH_PRODUCTS_RELATED_FAIL, error: e,
    });
  })
    .finally(() => {
      finallyCallback();
    });
};

export const getProductsGeneric = (User, sku) => {
  return new Promise((resolve, reject) => {
    genericSupplierEndpoint(User)
      .get(`/Product/Sku/${sku}`)
      .then((data) => {
        resolve(data)
      }
      )
      .catch((err) => {
        reject(err);
      });
  });
};

export const resetRelatedProducts = () => {
  Store.dispatch({ type: RESET_RELATED_PRODUCTS });

};